import React, { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";

import { useReport } from "../hooks/useReport";
import ReportTable from "../ReportTable";
import OutstandingReportFilter from "./OutstandingReportFilter";

import {
  batchUpdateAppliedFilters,
  initialOutstandingFilters,
} from "../redux/ReportsSlice";

import { getReportConfig } from "../optionsConfig";

import totalOutstanding from "../../../../common/assets/images/notification-box.png";
import highPriority from "../../../../common/assets/images/highPriority.png";
import calendar from "../../../../common/assets/images/calendar.png";
import hourglass from "../../../../common/assets/images/hourglass.png";
import usersreport from "../../../../common/assets/images/usersreport.png";
import { toast, ToastContainer } from "react-toastify";

import "./OutstandingReport.css";

const REPORT_PATH = "/outstanding-report";
const reportAPIConfig = getReportConfig(REPORT_PATH);

const OutstandingReport = () => {
  const dispatch = useDispatch();

  const appliedFilters = useSelector(
    (s) => s.reports.appliedFilters[REPORT_PATH] || {}
  );

   const { episodeAssignmentResponse } = useSelector(
      (state) => state.healthInsuranceManager.healthInformationManagerAssignment,
    );


  const {
    episodes,
    reportData,
    totalPages,
    pageNumber,
    setPageNumber,
    reportLoading,
    reportError,
    exportLoading,
    handleReset,
    resetSignal,
    setSortPayload,
    setPageSize,
    pageSize
  } = useReport(REPORT_PATH);

  const [searchText, setSearchText] = useState("");

  /* ---------- SEARCH ---------- */

  const handleSearchChange = useCallback(
    (value) => {
      setSearchText(value || "");

      dispatch(
        batchUpdateAppliedFilters({
          reportPath: REPORT_PATH,
          filters: { search: value || "" },
        })
      );

      setPageNumber(1);
    },
    [dispatch, setPageNumber]
  );

   useEffect(() => {
  const updatePageSize = () => {
    const screenHeight = window.innerHeight;

    // header + widgets + pagination space
    const availableHeight = screenHeight - 335;

    // approximate row height
    const rowHeight = 36;

    const dynamicRows = Math.floor(availableHeight / rowHeight);

    setPageSize(dynamicRows > 10 ? dynamicRows : 10);
  };

  updatePageSize();

  window.addEventListener("resize", updatePageSize);

  return () => {
    window.removeEventListener("resize", updatePageSize);
  };
}, []);

  /* ---------- COLUMN FILTER ---------- */

  const handleColumnFilterApply = useCallback(
    (filters) => {
      dispatch(
        batchUpdateAppliedFilters({
          reportPath: REPORT_PATH,
          filters,
        })
      );

      setPageNumber(1);
    },
    [dispatch, setPageNumber]
  );


useEffect(() => {
  sessionStorage.setItem("workspaceRole", "coder");
}, []);

 useEffect(() => {
    if (episodeAssignmentResponse.message) {
      toast.success("Assigned episodes successfully");
      // initialOutstandingFilters
      handleReset?.();
    }
  }, [episodeAssignmentResponse]);

  /* ---------- CARDS ---------- */

//  const cards = reportData?.body?.cards || reportData?.cards || reportData?.data?.cards;
//  const hasCards = cards && Object.values(cards).some((v) => v != null);

//   const widgets = [
//     {
//       label: "Total Outstanding",
//       count: cards?.total_outstanding_episodes,
//       bgColor: "#EFF6FF",
//       icon: totalOutstanding,
//     },
//     {
//       label: "High Priority",
//       count: cards?.high_priority,
//       bgColor: "#FEF2F2",
//       icon: highPriority,
//     },
//     {
//       label: "30+ Days Old",
//       count: cards?.["30_days_or_old"],
//       bgColor: "#FEFCE8",
//       icon: calendar,
//     },
//     {
//       label: "Avg Days Outstanding",
//       count:
//         cards?.avg_days_of_outstanding != null
//           ? Number(cards.avg_days_of_outstanding).toFixed(2)
//           : "-",
//       bgColor: "#ECFDF5",
//       icon: hourglass,
//     },
//     {
//       label: "Unassigned",
//       count: cards?.unassigned_coder,
//       bgColor: "#EBEBEB",
//       icon: usersreport,
//     },
//   ];

  return (
    <>
          <ToastContainer position="top-right" autoClose={3000} />
    <div className="outstanding-filters-section mt-3 px-2">
      <h4 className="pb-2" style={{ flexShrink: 0 }}>
        Outstanding Coding Report
      </h4>

      {/* WIDGET CARDS */}
      {/* {hasCards && (
        <div className="d-flex gap-2 mb-3 flex-wrap" style={{ flexShrink: 0 }}>
          {widgets.map((w) => (
            <div key={w.label} className="outstanding-widget col" style={{ background: w.bgColor }}>
              <div>
                <p className="mb-1">{w.label}</p>
                {reportLoading ? (
                  <Skeleton width={60} />
                ) : (
                  <p className="mb-0 fw-bold">{w.count ?? '-'}</p>
                )}
              </div>

              <div>
                <img src={w.icon} alt={w.label} />
              </div>
            </div>
          ))}
        </div>
      )} */}

      {/* TABLE */}
      <ReportTable
        key="outstanding"
        episodes={episodes}
        isReportLoading={reportLoading}
        isReportError={reportError}
        reportPageNumber={pageNumber}
        setReportPageNumber={setPageNumber}
        totalPages={totalPages}
        pageSize={pageSize}
        setPageSize={setPageSize}
       searchText={searchText}
        setSearchText={setSearchText}
        handleSearchChange={handleSearchChange}
        // handleReportExport={handleExport}
        reportExcelLoading={exportLoading}
        onSortChange={setSortPayload}
        onReset={handleReset}
        resetSignal={resetSignal}
        onColumnFilterApply={handleColumnFilterApply}
        reportData = {reportData}
      />

      <OutstandingReportFilter />
    </div>
    </>
  );
};

export default OutstandingReport;
